export const isValid = (pw1: string, pw2: string) => {
  if (pw1 === pw2) {
    return true;
  } else {
    return false;
  }
};
